/**
 * Created by 刘娟娟 on 2016/8/15.
 */
const constant = {
  API_URL: 'http://139.196.178.191:8080',
  socketHost: 'https://data.topxgun.com:61234'
}
export default constant



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/